import type { VisibleBreakpoints } from 'styles/constants';

export type HeroTextBoxProps = {
  $visible?: Partial<VisibleBreakpoints>;
  $verticalAlign?: 'start' | 'center' | 'end';
  $horizontalAlign?: 'start' | 'center' | 'end';
};

export type HeroImageContainerTypes = {
  $rounded: boolean | null | undefined;
  $styled: boolean | null | undefined;
  $height: number;
  $expandedImage?: boolean;
};

export type HeroContainerTypes = {
  $expandedImage?: boolean;
};

export enum MobileOrder {
  image_top = 1,
  image_center = 2,
  image_bottom = 3,
}
